import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateSupportNotificationHTML = (userName, accountNumber, transactionData) => {
  const amount = typeof transactionData.amount === 'number' ? transactionData.amount.toFixed(2) : transactionData.amount;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>New Transaction/Withdrawal</h1>
        </div>
        <div class="content">
          <p>A new transaction has been initiated on ${BRAND_NAME}.</p>
          
          <div class="info-box">
            <p><span class="label">User Name:</span> ${userName}</p>
            <p><span class="label">User Account:</span> ${accountNumber}</p>
            <p><span class="label">Beneficiary:</span> ${transactionData.beneficiary}</p>
            <p><span class="label">Beneficiary Account/Wallet:</span> ${transactionData.beneficiaryAccount || transactionData.walletAddress}</p>
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Date:</span> ${transactionData.date}</p>
            <p><span class="label">Type:</span> ${transactionData.type}</p>
            <p><span class="label">Status:</span> ${transactionData.status || "Pending"}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${BASE_URL}/admin" class="btn">Moderate Transaction</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

const generateUserConfirmationHTML = (userName, accountNumber, transactionData) => {
  const amount = typeof transactionData.amount === 'number' ? transactionData.amount.toFixed(2) : transactionData.amount;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 10px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Transaction Initiated</h1>
        </div>
        <div class="content">
          <p>Hello <strong>${userName}</strong>,</p>
          <p>Your transaction request was successfully received and is being processed.</p>
          
          <div class="info-box">
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Coin:</span> ${transactionData.beneficiary}</p>
            <p><span class="label">Wallet Address:</span> ${transactionData.beneficiaryAccount || transactionData.walletAddress}</p>
            <p><span class="label">Date:</span> ${transactionData.date}</p>
          </div>
          
          <p>You can track this transaction in your dashboard.</p>
          
          <div style="text-align: center;">
            <a href="${BASE_URL}/dashboard" class="btn">Go to Dashboard</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendNotificationToSupport = async (userEmail, accountNumber, userName, transactionData) => {
  try {
    const html = generateSupportNotificationHTML(userName, accountNumber, transactionData);
    await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    return true;
  } catch (error) {
    console.error("❌ Error sending support notification:", error);
    return false;
  }
};

export const sendConfirmationToUser = async (userEmail, accountNumber, userName, transactionData) => {
  try {
    const html = generateUserConfirmationHTML(userName, accountNumber, transactionData);
    await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: userName,
        user_email: userEmail,
        html: html,
      },
      PUBLIC_KEY
    );
    return true;
  } catch (error) {
    console.error("❌ Error sending user confirmation:", error);
    return false;
  }
};

// Send Email Function (Matches existing signature)
export const sendTransactionEmail = async (userEmail, accountNumber, userName, transactionData) => {
  console.log("📧 Sending transaction/withdrawal emails...", { userEmail, transactionData });
  const supportResult = await sendNotificationToSupport(userEmail, accountNumber, userName, transactionData);
  const userResult = await sendConfirmationToUser(userEmail, accountNumber, userName, transactionData);
  return supportResult && userResult;
};
